import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpDataService } from 'core/services/http-data.service';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';

@Injectable()
export class SftpConfigurationsService extends HttpDataService {
  constructor(protected injector: Injector, private translateService: TranslateService) {
    super(injector, '/sftp/config');
  }

  getSftpConfig(clientId: string): Promise<any> {
    const url = `${this.baseUrl}/${clientId}`;
    return lastValueFrom(super.fetchRequest(url, null));
  }

  getReportColumns(): Promise<any> {
    const url = `${this.apiUrl}/reporting/data-dump/columns`;
    return lastValueFrom(this.http.get(url, { headers: { 'accept-language': this.translateService.currentLang } }));
  }

  updateSftpConfig(clientId: string, sftpConfig: any): Promise<any> {
    const url = `${this.baseUrl}/${clientId}`;
    return super.putRequest(url, sftpConfig, this.getRequestOptions());
  }
}
